// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2zY42","right":"Footer_right__2hD_X","buttons":"Footer_buttons__3gOzK"};